import { Image } from '@graphcommerce/image'
import { Tooltip } from '@mui/material'
import Link from 'next/link'
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel'
import arrowLeft from '../../assets/images/arrow-left-outline.svg'
import arrowRight from '../../assets/images/arrow-right-outline.svg'
import useWindowSize from '../../hooks/useWindowSize'

export type CategoryChildSliderProps = {
  children?: any[] | undefined
  className?: string
}
export function CategoryChildSlider(props: CategoryChildSliderProps) {
  const { children, className } = props
  const { isMobile } = useWindowSize()
  return (
    <CarouselProvider
      naturalSlideWidth={5}
      naturalSlideHeight={1}
      totalSlides={children?.length ?? 0}
      // eslint-disable-next-line no-nested-ternary
      visibleSlides={isMobile ? 1 : (children?.length ?? 0) < 4 ? children?.length ?? 0 : 4}
      infinite
      isIntrinsicHeight
      className={`grid w-auto grid-cols-[5fr_90fr_5fr] gap-[10px] self-center md:w-full ${className}`}
    >
      <ButtonBack className='flex items-center justify-center justify-self-start hover:scale-110'>
        <Image src={arrowLeft} alt='Back' layout='fixed' unoptimized height={25} width={25} />
      </ButtonBack>
      <Slider className='align-middle'>
        {children?.map((child, index) => (
          <Slide index={index} className='max-w-none md:max-w-[260px]'>
            <Link href={child.url_path ?? ''} className='h-full align-middle'>
              <Tooltip title={child.name} arrow>
                <div className='mx-2 flex w-auto items-center justify-center rounded-[20px] bg-bright-templi-purple px-2 py-2 text-center text-pure-white hover:bg-bright-templi-purple-hover hover:shadow-md md:mx-3 lg:mx-8'>
                  <span className='Type-Large-Regular truncate whitespace-nowrap px-2'>
                    {child.name}
                  </span>
                </div>
              </Tooltip>
            </Link>
          </Slide>
        ))}
      </Slider>
      <ButtonNext className='flex items-center justify-center justify-self-end hover:scale-110'>
        <Image src={arrowRight} alt='Back' layout='fixed' unoptimized height={25} width={25} />
      </ButtonNext>
    </CarouselProvider>
  )
}
